import EventScheduleUpdateMapper from './event-schedule-update-mapper';

const EventScheduleUpdateModel = {
    mapper: EventScheduleUpdateMapper,

    categoryId: {
        fieldName: 'c',
        type: String,
    },

    eventId: {
        fieldName: 'e',
        type: String,
    },

    leagueId: {
        fieldName: 'g',
        type: String,
    },

    live: {
        fieldName: 'l',
        type: Boolean,
    },

    newScheduleDate: {
        fieldName: 'n',
        type: Number,
    },

    scheduleDate: {
        fieldName: 'd',
        type: Number,
    },

    sportId: {
        fieldName: 's',
        type: String,
    },

    type: {
        fieldName: 't',
        type: String,
    },
};

export default EventScheduleUpdateModel;
